module.exports = __webpack_public_path__ + "static/media/DevelopmentIcon.4c38a21c.svg";